import {isNil} from 'app/util/isNil';

export function useDeployment() {
  const deployment = DEPLOYMENT;

  if (isNil(deployment)) {
    return undefined;
  }

  if (deployment === 'go' || deployment === 'eu') {
    return deployment;
  }

  return 'go';
}
